module.exports = __webpack_public_path__ + "static/img/qem-logo-white.eccc481b.png";